import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Unsubscribe } from '@mui/icons-material';
import useExtractPlan from './useExtractPlan';
import { useProfile } from '../context/ProfileProvider/useProfile';
import { KeydrivePlan, EnumSignture } from '../model/UserModel';

export const useFreePlanDialog = () => {
    const { nameOrg } = useParams();
    const [openKeyDriveDialog, setKeyDriveDialog] = useState<boolean>(false);
    const { keydrivePlan } = useExtractPlan();
    const profile = useProfile();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const shouldShowDialog = 
        keydrivePlan === KeydrivePlan.FREE && 
        !profile.adminSystem && 
        profile?.signture?.signture !== EnumSignture.Canceled;

    useEffect(() => {
        if (keydrivePlan === KeydrivePlan.FREE) {
            setKeyDriveDialog(true);
        }
    }, [keydrivePlan]);

    const handleClose = () => {
        setKeyDriveDialog(false);
    };

    const handleNavigateToPlans = () => {
        setKeyDriveDialog(false);
        navigate(`/${nameOrg}/adminConsole/plans`);
    };

    const dialogProps = {
        keyDriveDialogButtons: {
            leftButtonMethod: handleClose,
            rightButtonMethod: handleNavigateToPlans,
            rightButtonText: t("AdminConsole.FreeTier.AccessPlans")
        },
        keyDriveDialogContent: {
            dialogContent: t("AdminConsole.FreeTier.FreeContent"),
            dialogIcon: <Unsubscribe sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
            dialogTitle: t("AdminConsole.FreeTier.FreeTitle"),
            handleTogglDialog: () => {},
            openDialog: openKeyDriveDialog
        },
        dialogTitleCenter: true
    };

    return {
        shouldShowDialog,
        openKeyDriveDialog,
        setKeyDriveDialog,
        dialogProps
    };
};